import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
import { ImageProcessingStatus as r } from "@maat/api-main/types";
//#region src/properties/usePropertyImagesQuery.ts
var i = 3e3, a = (a, o, s) => {
	let c = s?.poll ?? !0;
	return t({
		queryKey: e.images(a, o.listingId),
		queryFn: () => n.getListingImages(a, o),
		refetchInterval: (e) => c && (e.state.data?.images ?? []).some((e) => e.processing_status === r.Pending) ? i : !1
	});
};
//#endregion
export { a as usePropertyImagesQuery };
